import { FrownTwoTone } from '@ant-design/icons';
import TaggedButton from '@components/TaggedButton';
import TaggedModal from '@components/TaggedModal';
import routeNames from '@modules/router/src/routeNames';
import { Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

interface TimeOutModalProps {
  showModal: boolean
  closeModal: () => void
}

const TimeOutModal = (props: TimeOutModalProps) => {
  const navigate = useNavigate();

  const { showModal, closeModal } = props;

  const onClose = () => {
    navigate(routeNames.home);
    closeModal();
  };

  return (
    <TaggedModal
      tag="previewModal"
      open={showModal}
      onCancel={onClose}
      destroyOnHidden
      footer={null}
    >
      <Space direction="vertical" style={{ alignItems: 'center', width: '100%' }}>
        <FrownTwoTone style={{ fontSize: 80 }} />
        <Title level={4}>Your session has expired</Title>
        <Title level={5}>Please login again.</Title>
        <TaggedButton tag="close-inactive-modal" type="primary" onClick={onClose}>Close</TaggedButton>
      </Space>
    </TaggedModal>
  );
};

export default TimeOutModal;
